import axios from '@/libs/api.request'
const product = {
  // 分类列表
  getProduct: (data) => {
    return axios.post({
      url: '/Product',
      data: data
    })
  },
  // 商品ABC对应分类列表
  getProductTypeList: () => {
    return axios.get({
      url: '/Product/ProductTypeListByABC'
    })
  },
  // 获取商品ABC对应报废类型
  getSysCodeList: () => {
    return axios.get({
      url: '/Product/SysCodeListByABC'
    })
  },
  // 根据中类小类获取商品分类列表
  getProductTypeListByFLag: (data) => {
    return axios.post({
      url: '/Product/ProductTypeListByFLag',
      data: data
    })
  },
  // 获取商品ABC对应商品标签表头
  getColumnsList: () => {
    return axios.get({
      url: '/Product/ColumnsListByABC'
    })
  },
  // 加载商品ABC数据
  getDataList: (data) => {
    return axios.post({
      url: '/Product/LoadDataListByABC',
      data: data
    })
  },

  // 加载商品ABC数据
  saveABC: (data) => {
    return axios.put({
      url: '/Product/abc',
      data: data
    })
  },
  // 获取添加商品标签的商品ABC数据
  getProductBQ: (data) => {
    return axios.post({
      url: '/Product/loadProductBQ',
      data: data
    })
  },
  // 价格带
  getProductPriceZone: (data) => {
    return axios.post({
      url: '/Product/PriceZone',
      data: data
    })
  },
  // 商品价格分析列表
  getProductPriceDetail: (data) => {
    return axios.post({
      url: '/Product/PriceDetail',
      data: data
    })
  },
  // 客单时间段报表
  getProductSalesTime: (data) => {
    return axios.post({
      url: '/Product/SalesTime',
      data: data
    })
  },
  // 根据分类获取商品
  getProductData: (data) => {
    return axios.post({
      url: '/Product/Product',
      data: data
    })
  },
  // 商品ABC时间分析
  getProductABCSalesTime: (data) => {
    return axios.post({
      url: '/Product/ProductABC/SalesTime',
      data: data
    })
  },
  // 单品报废占比
  getReturnPercent: (data) => {
    return axios.post({
      url: '/Product/ProductABC/ReturnPercent',
      data: data
    })
  },
  // 单品毛利占比
  getProfitPercent: (data) => {
    return axios.post({
      url: '/Product/ProductABC/ProfitPercent',
      data: data
    })
  },
  // 分类报废占比
  getTypeReturnPercent: (data) => {
    return axios.post({
      url: '/Product/ProductABC/TypeReturnPercent',
      data: data
    })
  },
  // 分类毛利占比
  getTypeProfitPercent: (data) => {
    return axios.post({
      url: '/Product/ProductABC/TypeProfitPercent',
      data: data
    })
  },
  // 分类销售占比
  getTypeSalesPercent: (data) => {
    return axios.post({
      url: '/Product/ProductABC/TypeSalesPercent',
      data: data
    })
  },
  // 单分类销售占比
  getSingleTypeSalesPercent: (data) => {
    return axios.post({
      url: '/Product/ProductABC/SingleTypeSalesPercent',
      data: data
    })
  }
}
export default product



// WEBPACK FOOTER //
// ./src/api/api-product.js